import HTTP from '@/components/general/http/http'

import config from '@/config/env'

export default {
	getSellers(data) {

		let url = config.api.baseUrl + '/api/sellers' + data

		return HTTP
			.request()
			.get(url)
			.then(response => response)
			.catch(error => error)

	},
	createSeller(data) {

		let url = config.api.baseUrl + '/api/sellers'

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	},
	updateSeller(data) {

		let url = config.api.baseUrl + '/api/sellers'

		return HTTP
			.request()
			.put(url, data)
			.then(response => response)
			.catch(error => error)

	},
	deleteSeller(data) {

		let url = config.api.baseUrl + '/api/sellers' + data

		return HTTP
			.request()
			.delete(url)
			.then(response => response)
			.catch(error => error)

	},
	exportUsers(data) {

		let url = config.api.baseUrl + '/api/sellers/export'

		return HTTP
			.request()
			.post(url, data, {
				responseType: 'arraybuffer'
			})
			.then(response => response)
			.catch(error => error)

	},
	migrateCSVFile(data) {

		let url = config.api.baseUrl + '/api/sellers/migrate'

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	}
}



// WEBPACK FOOTER //
// ./src/api/sellers.js